<template>
  <div class="issuing-ticket" :class="{ 'is-paused': paused }" aria-hidden="true">
    <svg class="issuing-ticket__scene" viewBox="0 0 340 250" fill="none">
      <defs>
        <linearGradient :id="id + '-face'" x1="38" y1="62" x2="291" y2="216" gradientUnits="userSpaceOnUse">
          <stop stop-color="#353c49" /><stop offset=".45" stop-color="#202631" /><stop offset="1" stop-color="#11161f" />
        </linearGradient>
        <linearGradient :id="id + '-edge'" x1="45" y1="65" x2="300" y2="197" gradientUnits="userSpaceOnUse">
          <stop stop-color="#edf2ff" stop-opacity=".7" /><stop offset=".45" stop-color="#758198" stop-opacity=".18" /><stop offset="1" stop-color="#b7c3d8" stop-opacity=".55" />
        </linearGradient>
        <linearGradient :id="id + '-beam'" x1="0" y1="48" x2="0" y2="219" gradientUnits="userSpaceOnUse">
          <stop stop-color="#e5edff" stop-opacity="0" /><stop offset=".5" stop-color="#e5edff" stop-opacity=".85" /><stop offset="1" stop-color="#e5edff" stop-opacity="0" />
        </linearGradient>
        <radialGradient :id="id + '-halo'"><stop stop-color="#a5b7d5" stop-opacity=".12" /><stop offset="1" stop-color="#a5b7d5" stop-opacity="0" /></radialGradient>
        <clipPath :id="id + '-reveal'"><rect class="issuing-ticket__reveal" width="340" height="230" /></clipPath>
      </defs>

      <ellipse cx="170" cy="139" rx="166" ry="103" :fill="'url(#' + id + '-halo)'" />
      <g class="issuing-ticket__cycle">
      <ellipse class="issuing-ticket__shadow" cx="171" cy="222" rx="100" ry="8" fill="#03060c" opacity=".4" />
      <g :clip-path="'url(#' + id + '-reveal)'">
      <g class="issuing-ticket__float">
        <g transform="rotate(-7 170 136)">
          <path class="issuing-ticket__ghost" :d="ticketPath" transform="translate(6 -13) rotate(5 170 136)" fill="#181e28" stroke="#8b9bb7" stroke-opacity=".12" />
          <path class="issuing-ticket__face" :d="ticketPath" :fill="'url(#' + id + '-face)'" />
          <path class="issuing-ticket__outline" :d="ticketPath" :stroke="'url(#' + id + '-edge)'" stroke-width="1.2" pathLength="1" />

          <g class="issuing-ticket__brand">
            <image :href="logo" x="55" y="88" width="129" height="16" preserveAspectRatio="xMinYMid meet" />
            <text x="55" y="125" class="issuing-ticket__label">FOMO PASS</text>
          </g>
          <g class="issuing-ticket__details">
            <rect x="55" y="143" width="122" height="7" rx="3.5" fill="#c6d2e7" fill-opacity=".52" />
            <rect x="55" y="158" width="88" height="5" rx="2.5" fill="#a4b4cf" fill-opacity=".24" />
            <rect x="55" y="181" width="34" height="4" rx="2" fill="#a4b4cf" fill-opacity=".3" />
            <rect x="101" y="181" width="51" height="4" rx="2" fill="#a4b4cf" fill-opacity=".17" />
          </g>

          <path class="issuing-ticket__perforation" d="M219 80V196" stroke="#c4d0e4" stroke-opacity=".22" stroke-dasharray="3 5" />
          <g class="issuing-ticket__code">
            <rect x="235" y="108" width="54" height="54" rx="10" fill="#dbe5f6" fill-opacity=".055" />
            <path d="M245 126v-9h9M270 117h9v9M279 145v9h-9M254 154h-9v-9" stroke="#d4dff1" stroke-opacity=".6" stroke-width="2" stroke-linecap="round" />
            <rect v-for="cell in cells" :key="cell.key" class="issuing-ticket__pixel" :x="cell.x" :y="cell.y" width="3.5" height="3.5" rx=".7" fill="#cedbef" />
          </g>
          <text class="issuing-ticket__stub-label" x="262" y="180" text-anchor="middle">ACCESO</text>
        </g>
      </g>
      </g>
      <path class="issuing-ticket__beam" d="M0 48V219" :stroke="'url(#' + id + '-beam)'" stroke-width="2" />
      </g>
      <rect class="issuing-ticket__track" x="58" y="241" width="224" height="3" rx="1.5" fill="#d4dff1" opacity=".12" />
      <g class="issuing-ticket__bar"><rect class="issuing-ticket__progress" x="58" y="241" width="224" height="3" rx="1.5" fill="#bac9e2" /></g>
    </svg>
  </div>
</template>

<script>
import { getCurrentInstance } from 'vue'
import logo from '../../../../static/LOGOFOMO26_pro.png'

// Abstract code modules are decorative; this loader never contains an access QR.
const pattern = ['101101', '010110', '111001', '001110', '101011', '011100']
const cells = pattern.flatMap((row, y) => row.split('').flatMap((cell, x) => cell === '1'
  ? [{ key: `${x}-${y}`, x: 249 + x * 4.5, y: 122 + y * 4.5 }]
  : []))
export default {
  name: 'TicketIssuingAnimation',
  props: { paused: Boolean },
  setup() {
    return {
      id: `issuing-ticket-${getCurrentInstance().uid}`,
      logo, cells,
      ticketPath: 'M52 68H219A9 9 0 0 0 237 68H288A16 16 0 0 1 304 84V124A12 12 0 0 0 304 148V192A16 16 0 0 1 288 208H237A9 9 0 0 0 219 208H52A16 16 0 0 1 36 192V148A12 12 0 0 0 36 124V84A16 16 0 0 1 52 68Z',
    }
  },
}
</script>

<style scoped>
.issuing-ticket { --ticket-cycle: 5.4s; width: 100%; }
.issuing-ticket__scene { display: block; width: 100%; height: auto; overflow: visible; }
.issuing-ticket__label { fill: #c2cee1; font: 500 8px var(--fomo-font-label); letter-spacing: 2px; }
.issuing-ticket__stub-label { fill: #8293af; font: 500 7px var(--fomo-font-label); letter-spacing: 1.1px; }
/* One timeline reveals the ticket and fills the decorative bar, then clears both. */
.issuing-ticket__cycle, .issuing-ticket__bar { animation: ticket-cycle-fade var(--ticket-cycle) linear infinite; }
.issuing-ticket__reveal { transform-origin: 0 0; animation: ticket-reveal var(--ticket-cycle) linear infinite; }
.issuing-ticket__progress { transform-box: fill-box; transform-origin: left center; animation: ticket-reveal var(--ticket-cycle) linear infinite; }
.issuing-ticket__float { animation: ticket-rise var(--ticket-cycle) linear infinite; }
.issuing-ticket__beam { animation: ticket-reveal-beam var(--ticket-cycle) linear infinite; }
.issuing-ticket.is-paused * { animation: none; }
.issuing-ticket.is-paused .issuing-ticket__cycle { opacity: .45; }
.issuing-ticket.is-paused .issuing-ticket__reveal { transform: scaleX(1); }
.issuing-ticket.is-paused :is(.issuing-ticket__beam, .issuing-ticket__bar, .issuing-ticket__track) { display: none; }
@keyframes ticket-reveal {
  0%, 8% { transform: scaleX(0); }
  66%, 94% { transform: scaleX(1); }
  100% { transform: scaleX(0); }
}
@keyframes ticket-cycle-fade {
  0%, 6% { opacity: 0; }
  12%, 76% { opacity: 1; }
  90%, 100% { opacity: 0; }
}
@keyframes ticket-rise {
  0%, 8% { transform: translateY(6px); }
  66%, 76% { transform: translateY(0); }
  90%, 100% { transform: translateY(-6px); }
}
@keyframes ticket-reveal-beam {
  0%, 8% { transform: translateX(0); opacity: 0; }
  12%, 64% { opacity: .9; }
  66%, 100% { transform: translateX(340px); opacity: 0; }
}
@media (prefers-reduced-motion: reduce) {
  .issuing-ticket * { animation: none !important; }
  .issuing-ticket__cycle { opacity: 1; }
  .issuing-ticket__reveal { transform: scaleX(1); }
  .issuing-ticket__beam, .issuing-ticket__bar, .issuing-ticket__track { display: none; }
}
</style>
